import axios, { AxiosError } from 'axios';
import { ApiError } from 'types';
import { readToken } from 'services/localStorage.service';
import * as Sentry from '@sentry/react';

export const httpApi = axios.create({
  baseURL: '/api/',
});

httpApi.interceptors.request.use((config) => {
  config.headers['Authorization'] = `Bearer ${readToken()}`;

  return config;
});
httpApi.interceptors.response.use(undefined, (error: AxiosError) => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status ?? 500;
    const data = error.response?.data as
      | {
          message?: string;
          status?: number;
        }
      | undefined;
    const apiError = new ApiError(
      status,
      data?.message ?? 'No se encontró el error'
    );

    if (status === 401) {
      const alink = document.createElement('a');
      alink.href = '/auth/logout';
      alink.click();
      return Promise.reject(apiError);
    } else if (status === 403) {
      const alink = document.createElement('a');
      alink.href = '/Forbidden';
      alink.click();
      return Promise.reject(apiError);
    }

    return Promise.reject(apiError);
  }
  Sentry.captureException({
    exception: error,
    message: 'No se encontró el error, un endpoint no funciona bien',
  });
  throw new ApiError(500, 'No se encontró el error');
});

export interface ApiErrorData {
  message: string;
  status: number;
}
